'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import CapabilityManagement from '../components/training/CapabilityManagement';
import TrainingTopicManagement from '../components/training/TrainingTopicManagement';
import TrainingApproval from '../components/training/TrainingApproval';
import FinalTrainingScheduling from '../components/training/FinalTrainingScheduling';
// Manager Evaluation & Skill Gap tabs removed per request (2026-10-13) — keep commented, not deleted.
// import ManagerEvaluation from '../components/training/Managerevaluation';
// import SkillGapReport from '../components/training/Skillgapreport';
import EmployeeAssessment from '../components/training/Employeeassessment';
import EmployeeFeedback from '../components/training/Employeefeedback';
import TrainingDelivery from '../components/training/Trainingdelivery';
import TrainingScorecard from '../components/training/Trainingscorecard';
// ─── Component ────────────────────────────────────────────────────────────────
export default function TrainingPageImpl() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const mainTab = (params.get('tab') || 'HR');
    const hrSub = (params.get('hrSub') || 'capability');
    const empSub = (params.get('empSub') || 'assessment');
    // ── Navbar height breakdown ──────────────────────────────────────────────
    //  Blue AppBar (title only)   :  56px  — always
    //  White main tab row         :  40px  — always on /training-page
    //  White sub-tab row          :  40px  — only for HR and employee tabs
    //
    //  All tabs except HR/employee  →  56 + 40        =  96px
    //  HR / employee                →  56 + 40 + 40   = 136px
    // ────────────────────────────────────────────────────────────────────────
    const hasSubTabs = mainTab === 'HR' || mainTab === 'employee';
    const topMargin = hasSubTabs ? 'mt-[136px]' : 'mt-[96px]';
    const renderContent = () => {
        switch (mainTab) {
            // ── HR: Capability → Topics → Scheduling ──────────────────────────
            case 'HR':
                return (_jsxs("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200", children: [hrSub === 'capability' && _jsx(CapabilityManagement, {}), hrSub === 'topics' && _jsx(TrainingTopicManagement, {}), hrSub === 'scheduling' && _jsx(FinalTrainingScheduling, {})] }));
            // ── Manager Evaluation ────────────────────────────────────────────
            // Removed from the tab bar per request (2026-10-13) — keep commented, not deleted.
            // case 'manager':
            //   return (
            //     <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            //       <ManagerEvaluation />
            //     </div>
            //   );
            // ── Skill Gap Report ──────────────────────────────────────────────
            // Removed from the tab bar per request (2026-10-13) — keep commented, not deleted.
            // case 'skillgap':
            //   return (
            //     <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            //       <SkillGapReport />
            //     </div>
            //   );
            // ── Management Approval ───────────────────────────────────────────
            case 'management':
                return (_jsx("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200", children: _jsx(TrainingApproval, {}) }));
            // ── Employee: Assessment → Feedback ───────────────────────────────
            case 'employee':
                return (_jsxs("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200", children: [empSub === 'assessment' && _jsx(EmployeeAssessment, {}), empSub === 'feedback' && _jsx(EmployeeFeedback, {})] }));
            // ── Training Delivery ─────────────────────────────────────────────
            case 'delivery':
                return (_jsx("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200", children: _jsx(TrainingDelivery, {}) }));
            // ── Scorecard ─────────────────────────────────────────────────────
            case 'scorecard':
                return (_jsx("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200", children: _jsx(TrainingScorecard, {}) }));
            default:
                return null;
        }
    };
    return (_jsxs("div", { className: "flex min-h-screen", style: { background: '#F3F5EF' }, children: [_jsx(Sidebar, {}), _jsxs("div", { className: "flex-1 flex flex-col", children: [_jsx(Navbar, {}), _jsx("main", { className: `p-4 ${topMargin}`, children: renderContent() })] })] }));
}
